import * as apiGetDetails from 'api/shoppingCart/GetShoppingCartGetDetailsIdV1';
import EntityType from 'types/ShoppingCart/EntityType';
import { Translation } from 'types/_general/Translation';

export * as Source from 'types/ShoppingCart/Source';

export type Type = {
	id: string | null;
	name: Translation.Type<string> | null;
	type: EntityType;
	source: string | null;
};

export function create(): Type {
	return {
		id: null,
		name: null,
		type: EntityType.RECIPE,
		source: null,
	};
}

export function mapFromApi(input: apiGetDetails.ProductItems): Type {
	return {
		id: input.source.id,
		name: input.source.nameTranslation,
		type: input.source.type as EntityType,
		source: input.source.childSource,
	};
}
